/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} East_Hour_Termite_EmpowerInputs */

const fr_east_hour_termite_empower = /** @type {(inputs: East_Hour_Termite_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des accès aux types d'événements`)
};

/**

* @param {East_Hour_Termite_EmpowerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const east_hour_termite_empower = /** @type {((inputs?: East_Hour_Termite_EmpowerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<East_Hour_Termite_EmpowerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_east_hour_termite_empower(inputs)
});